<template>
  <div>
    <common-dialog ref="dialog" width="300px" center title="导出BOM信息" @closed="onClosed">
      <template slot="form">
        <div style="text-align: center;margin-bottom: 30px;">
          <div style="margin-top: 15px;">
           <el-form-item label="下载日期"> <el-date-picker
            v-model.trim="DownloadDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="下载日期"
          ></el-date-picker></el-form-item>
          </div>
          <div style="margin-top: 15px;">
            <el-button type="primary" @click="onExport" >导出</el-button>
          </div>
       
        </div>
      </template>
    </common-dialog>  
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/production/teProduct").default,
      DownloadDate: this.$commonJs.getToday(),
      TeProductId:0
    };
  },
  computed: {},
  methods: {
    getData(val){
      this.TeProductId=val
    },
   onExport(){
    var params = { Id:this.TeProductId,DownloadDate:this.DownloadDate };
       
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.bomInfoExport(params).then(res => {
            loading.close();
            this.onClosed();
            this.close();
          })
   },
   onClosed(){
    this.DownloadDate=this.$commonJs.getToday();
    this.TeProductId=0;

   }

  },
};
</script>